// Read (display/edit) mapping — a superset. The provider now owns the employments collection and feeds
// BOTH the show-page Employment section and the edit modal, so deserialized rows carry the display-only
// fields the section renders (company logo/slug) and the `featured` flag used for ordering — in addition
// to the editable fields. `getAllByPrProfile` selects all view columns, so these are already fetched.
// `personHidden` ("hidden from this person's own profile") rides both mappings: the collection keeps
// hidden jobs so the modal can still manage them (the show page filters them out of display), and the
// modal's hide toggle writes the flag back through the ordinary update endpoint.
const readMapping = {
  id: "id",
  companyId: "company_id",
  companyMigrateId: "company_migrate_id",
  companyName: "company_name",
  companySlug: "company_slug",
  companyProfileImageUrl: "company_profile_image_url",
  title: "title",
  from: "started_at",
  to: "ended_at",
  featured: "person_featured",
  personHidden: "person_hidden",
};

// Write mapping — only the job-owned fields a create/update may set. The company is set by id alone
// (`company_id`); a brand-new company is created up front via qapi.companies.create in CompanyPicker, so
// the server never needs `company_name` here (it isn't permitted). The denormalized company display
// fields (slug, logo) are NOT writable, so they stay out. `featured` stays out too: person_featured is
// only settable through the feature/unfeature flip endpoints (the server rejects it on update), which is
// how one-featured-job-per-person is enforced.
const writeMapping = {
  id: "id",
  companyId: "company_id",
  title: "title",
  from: "started_at",
  to: "ended_at",
  personHidden: "person_hidden",
};

// Serializes an employment model object for a write, transforming camelCase keys to the API's snake_case
// (e.g. { companyId: 123 } -> { company_id: 123 }) over the writable subset only.
export function serializeModel(model) {
  return Object.keys(writeMapping).reduce((acc, key) => {
    acc[writeMapping[key]] = model[key];
    return acc;
  }, {});
}

// Deserializes an API row to a camelCase model over the full read mapping.
export function deserializeModel(model) {
  return Object.keys(readMapping).reduce((acc, key) => {
    acc[key] = model[readMapping[key]];
    return acc;
  }, {});
}
